import {useSelector} from 'react-redux';

import fwuService from '../../services/device/fwuService';
import {selectIotDeviceType} from '../../state/selectors/iotDevice';

const useIsFwuEnabledForDevice = () => {
    const type = useSelector(selectIotDeviceType);
    const result = fwuService.isFWUAvailable(type);

    return result;
};

export default useIsFwuEnabledForDevice;
